// https://hypergryph.feishu.cn/wiki/BlB3wOjOLiXX2Hko16KcVIQEnsc
var Share = /** @class */ (function () {
    function Share(props) {
        Object.defineProperty(this, "adapter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.adapter = props.adapter;
    }
    Object.defineProperty(Share.prototype, "type", {
        /**
         * share_type 参数
         */
        get: function () {
            var share_type = this.adapter.getStore().share_type;
            return share_type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Share.prototype, "by", {
        /**
         * share_by 参数
         */
        get: function () {
            var share_by = this.adapter.getStore().share_by;
            return share_by;
        },
        enumerable: false,
        configurable: true
    });
    return Share;
}());
export { Share };
